import Vue from 'vue'
import moment from 'moment';
import filterJS from '@/assets/js/filter';


Vue.prototype.$moment = moment
for (const key in filterJS) {
  Vue.filter(key,filterJS[key])
}


// 过滤器
Vue.filter('dateFilter', function (input) {
    return moment(input).format('YYYY-MM-DD HH:mm:ss')
  })
  Vue.filter('timeFilter', function (input) {
    return moment(input).format('HH:mm:ss')
  })
  
  Vue.filter('dateFil', function (input) {
    return moment(input).format('YYYY-MM-DD')
  })
  